// extracted by mini-css-extract-plugin
export default {"drawerWidth":"60px","drawerWidthOpen":"256px"};